import React from "react";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import ProductDefaultImage from "@assets/images/product-default.png";

const GiftModal = ({ product, visible, handleClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      visible={visible}
      onCancel={handleClose}
      width="456px"
      footer={[
        <Button key="submit" type="primary" onClick={handleClose}>
          {t("modal.ok")}
        </Button>,
      ]}>
      <div className="ant-modal-body-gift">
        <img
          src={product?.gift_image || ProductDefaultImage}
          alt="Gift"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = ProductDefaultImage;
          }}
        />
      </div>
      <div className="ant-modal-body-gift-detail">
        <h1>{product?.gift_name}</h1>
        {/* <div className="ant-modal-body-gift-detail-price">
          <h2>{t("modal.gift_price")}</h2>
          <span>{product?.gift_price}</span>
          <span>{t("currency_sign")}</span>
        </div> */}
        {product?.gift_desc ? <div className="ant-modal-body-gift-detail-desc">
          <h2>{t("modal.gift_desc")}</h2>
          <span>{product?.gift_desc}</span>
        </div> : null}
      </div>
    </Modal>
  );
};

export default GiftModal;
